import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';

import { UiNotificationTemplateData, UiNotificationType } from './ui-notification.types';

@Component({
  selector: 'ui-notification-content',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './ui-notification-content.component.html',
  styleUrls: ['./ui-notification-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationContentComponent {
  readonly templateData = input.required<UiNotificationTemplateData>();

  readonly config = computed(() => this.templateData().config);

  readonly icon = computed((): IconProp => {
    const icons: Record<UiNotificationType, IconName> = {
      success: 'circle-check',
      error: 'circle-xmark',
      info: 'circle-info',
    };

    return ['fas', icons[this.config().type]];
  });

  close(): void {
    this.templateData().close();
  }
}
